module.exports = __webpack_public_path__ + "img/logo.545de72f.png";